@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.root {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  border-radius: 15px;
  background: var(--light-40);
  width: 100%;

  @include container-shadow;
}

.header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  position: relative;
}

.buttonWrapper {
  position: absolute;
  right: -7px;
  top: -7px;
}

.content {
  width: 100%;

  [data-autopilot-system-redesign='on'] & {
    margin-right: -15px;
  }
}

[data-ff-post-approvals='on'] {
  .platforms {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

.platforms {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

[data-ff-post-approvals='on'] {
  .platformItem {
    flex-direction: column;
    gap: 5px;
    padding: 5px 2px;
  }
}

.platformItem {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;

  border-radius: 10px;
  border: 2px solid transparent;
  background-color: var(--dark-3);

  @include transition;
  cursor: pointer;
  &:hover {
    background-color: var(--dark-5);
  }

  &.active {
    border-radius: 10px;
    border: 2px solid var(--selected-stroke);
    background: var(--selected-fill-10);
  }

  &.showStatusOverlay {
    margin-right: 4px;

    [data-autopilot-system-redesign='on'] & {
      margin-right: 0;
    }
  }

  [data-autopilot-system-redesign='on'] & {
    padding: 5px 13px;
    max-width: 52px;
    border-radius: 8px;
    border: 1px solid var(--dark-8);
    background: var(--light-100);

    &.showPostSettings {
      max-width: 60px;
      gap: 8px;
    }
  }
}

.label {
  @include xs-sohne-book;
  color: var(--dark-60);

  &.error {
    color: var(--red-70);
  }

  [data-ff-post-approvals='on'] & {
    display: flex;
    background-color: transparent;
    color: var(--dark-80);
    font-family: Sohne;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: 0.2px;

    &.errorLabel {
      color: var(--red-70);
    }
  }

  [data-autopilot-system-redesign='on'] & {
    font-weight: 400;
  }
}

.iconWithStatus {
  display: flex;
  align-items: center;
  position: relative;
}

.status {
  display: flex;
  align-items: center;
}

.alertIcon {
  position: absolute;
  top: 0;
  right: 0;
}

.iconWithPlatformName {
  display: flex;
  align-items: center;

  &.connect {
    > div > svg {
      opacity: 0.4;
    }
  }
}

.integrationCount {
  position: absolute;
  right: -3px;
  top: -3px;
  display: flex;
  width: 16px;
  height: 16px;
  padding: 0 1px 1px 1px;
  justify-content: center;
  align-items: center;
  background-color: var(--dark-80);
  border-radius: 12px;
  gap: 2px;

  span {
    [data-autopilot-system-redesign='on'] & {
      padding-top: 1px;
    }
  }

  &.integrationCountError {
    background-color: var(--red-90);
    width: 30px;
    height: 18px;
  }

  &.integrationCountWarning {
    background-color: var(--yellow-50);
    width: 30px;
    height: 18px;
  }

  &.integrationCountSuccess {
    background-color: var(--green-50);
    width: 30px;
    height: 18px;
  }

  .countLabel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10px;

    .svg {
      width: 40px;
    }
  }
}

.error {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 3px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 99px;
  background: linear-gradient(0deg, var(--red-50) 0%, var(--red-50) 100%), var(--light-100);
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.14);
}

.warning {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 3px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 99px;
  background: linear-gradient(0deg, var(--yellow-50) 0%, var(--yellow-50) 100%), var(--light-100);
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.14);
}

[data-ff-post-approvals='on'] {
  .toggleButton {
    padding: 0;
  }
}

@include for-phone-only {
  .toggleButton {
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 0;
    gap: 8px;
  }
}

.toggleButton {
  padding: 4px 0;
}

.postSettingsButtonGroup {
  display: flex;
  align-items: center;
  gap: 4px;
}

.postSettingsButton {
  &:hover {
    background-color: transparent;
  }
}

.actionElement {
  [data-autopilot-system-redesign='on'] & {
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
